import React, { Component } from 'react'
import { Grid, Row, Col, Modal } from 'react-bootstrap'

import i18next from 'i18next'
import linkifyHtml from 'linkifyjs/html'

import Button from './Button'

import styles from './styles/questionnaire.scss'
import illustration from './../assets/images/wopi360-intro-2x.png'

export default class Wopi360Start extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      consentGiven: false
    }
  }

  handleStart = () => {
    this.props.onStart()
  }

  handleTermsClose = () => {
    this.setState({
      showModal: false
    })
  }

  handleTermsOpen = e => {
    this.setState({
      showModal: true
    })
  }

  toggleConsentGiven = ({ target }) => this.setState({ consentGiven: target.checked })

  render() {
    const { language, target } = this.props

    const t = text => i18next.t(text, { lng: language, ns: 'wopi360Test' })

    return (
      <Grid className={styles.introductionText}>
        <Modal show={this.state.showModal}>
          <Modal.Header closeButton onHide={this.handleTermsClose}>
            <Modal.Title>{t('terms_and_conditions')}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p
              dangerouslySetInnerHTML={{
                __html: linkifyHtml(t('terms_and_conditions_description').replace(/\\n/g, '<br />'))
              }}
            />

            <Button text={t('close')} onClick={this.handleTermsClose} />
          </Modal.Body>
        </Modal>

        <Row>
          <Col md={12}>
            <h1>
              {t('evaluated_target_person_is')} {target.givenName} {target.familyName}
            </h1>

            <Row>
              <Col md={7} style={{ textAlign: 'left' }}>
                <h2>{t('evaluate_persons_work')}</h2>
                <p>{t('evaluate_persons_work_description')}</p>

                <h2>{t('answer_honestly')}</h2>
                <p>{t('answer_honestly_description')}</p>

                <h2>{t('answering_will_take')}</h2>
                <p>{t('answering_will_take_description')}</p>

                <p>
                  <label style={{ marginBottom: '0', marginTop: '10px' }}>
                    <input
                      type="checkbox"
                      name="consentGiven"
                      checked={this.state.consentGiven}
                      onChange={this.toggleConsentGiven}
                    />
                    &nbsp;{t('i_accept')}&nbsp;
                    <a href="#" onClick={this.handleTermsOpen}>
                      {t('the_confidentiality_agreement')}
                    </a>.
                  </label>
                </p>
              </Col>

              <Col md={5}>
                <img src={illustration} className={styles.alternativeIllustration} />
              </Col>
            </Row>

            <button
              className={styles.button}
              onClick={this.handleStart}
              disabled={!this.state.consentGiven}
            >
              {t('start_questionnaire')}
            </button>
          </Col>
        </Row>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360Start.js